module.exports = __webpack_public_path__ + "img/white-arrow.b73519e3.svg";